import { AfterViewInit, Component, Input } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-interactive-map',
  standalone: true,
  imports: [],
  templateUrl: './interactive-map.component.html',
  styleUrl: './interactive-map.component.css'
})
export class InteractiveMapComponent implements AfterViewInit {
  @Input() latitude: number = 41.8719;
  @Input() longitude: number = 12.5674;

  private map!: L.Map;
  mapId: string = 'map-' + Math.random().toString(36).substring(2, 9) + parseInt(this.latitude.toString().replace('.', ''));;

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    // Initializing the map
    this.map = L.map(this.mapId, {
      center: [this.latitude, this.longitude],
      zoom: 15,
      zoomControl: false,

      // Disable map interactions
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      touchZoom: false,
      boxZoom: false,
      keyboard: false
    });

    // Addin OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(this.map);


    // Adding a marker
    L.circleMarker([this.latitude, this.longitude], {
      radius: 8,
      color: '#FFBA00',
      fillColor: '#FFBA00',
      fillOpacity: 1,
      weight: 2
    }).addTo(this.map);

    L.circle([this.latitude, this.longitude], {
      radius: 50,
      color: '#B3AF63',
      fillColor: '#B3AF63',
      fillOpacity: 0.1,
      weight: 1
    }).addTo(this.map);

  }
}
